import SecureRequest from "../utils/securerequest";

export const getChatPreviews = async (userId) => {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return await Request.get(`/v3/communication/${userId}/chats`);
};

export const getChatNotificationStatus = async (chatId, userId) => {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  const params = {
    user_id: userId,
  };
  return await Request.get(`/v3/communication/${chatId}/notification-status`, { params });
};

export const getMessages = async (userId) => {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return await Request.get(`/v3/communication/${userId}/sms`);
};

export const sendSMSToCaregiver = async (messageData) => {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return await Request.post(
    `/v3/communication/${messageData.outbound_user_id}/send-sms`,
    messageData
  );
};

export const updateMessagesParticipant = async (data) => {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return await Request.patch(`/v3/communication/messages-participant`, data);
};

export const getSmsFilePresignedUrl = async (messageId) => {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return await Request.get(`/v3/communication/${messageId}/sms-file-presigned`);
};

export const updateMessageById = async ({ messageId, data }) => {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return await Request.patch(`/v3/communication/${messageId}/sms-messages`, data);
};

/**
 * Fetches participant data for a specific chat.
 */
export const getMessagesParticipant = async (userId, chatId) => {
  const sr = new SecureRequest();
  const Request = sr.getRequest();

  const params = {
    user_id: userId,
  };

  return await Request.get(`/v3/communication/${chatId}/messages-participant`, { params });
};
